import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraIconTile } from '../ensigns/icon-tile';
import { SpecraText } from '../ensigns/typography';
/** Visual contents of one command-palette search result. */ export function SpecraCommandResult({ description, icon, label, meta, tone = 'neutral' }) {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            icon ? /*#__PURE__*/ _jsx(SpecraIconTile, {
                tone: tone,
                children: icon
            }) : null,
            /*#__PURE__*/ _jsxs("span", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ _jsx(SpecraText, {
                        className: "block truncate font-medium",
                        size: "caption",
                        children: label
                    }),
                    description ? /*#__PURE__*/ _jsx(SpecraText, {
                        className: "block truncate",
                        size: "caption",
                        tone: "muted",
                        children: description
                    }) : null
                ]
            }),
            meta ? /*#__PURE__*/ _jsx(SpecraText, {
                className: "shrink-0 rounded-sm bg-muted px-1.5 py-0.5",
                size: "micro",
                tone: "muted",
                children: meta
            }) : null
        ]
    });
}
